import React from 'react';
import styled from 'styled-components';
import { keys, size, map } from 'lodash';
import { Link, Redirect } from 'react-router-dom';
import { getStateFromStorage } from '../helpers/storage';
import { Button, LinkButton } from './Button';
import { UserName } from '../containers/UserName';
import { PageContainer, Input, H1, ButtonSet, Container } from './Layout';

const acceptedCharacters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

function randomString(length: number, chars: string) {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}

export const Join: React.FC = () => {
    const { userName } = UserName.useContainer();

    const [roomName, setRoomName] = React.useState('');

    const recentGames = keys(getStateFromStorage());

    return (
        <PageContainer>
            <Container>
                <H1>Welcome {userName}!</H1>
                <span>
                    Not {userName}? <Link to="/login">Logout</Link>
                </span>
                <Input
                    placeholder="The room to join"
                    value={roomName}
                    onChange={(e) => setRoomName(e.target.value)}
                    type="text"
                />
                <>
                    <ButtonSet>
                        <LinkButton disabled={!userName || !roomName} to={`/lobby/${roomName}`}>
                            Join
                        </LinkButton>
                    </ButtonSet>
                    <hr />
                    <ButtonSet>
                        <LinkButton
                            disabled={!userName}
                            to={`/lobby/${randomString(4, acceptedCharacters)}`}
                        >
                            Create new game
                        </LinkButton>
                    </ButtonSet>
                </>
            </Container>
            {!!size(recentGames) && (
                <Container>
                    <H1>Resume Last Game</H1>
                    {map(recentGames, (recentGame) => (
                        <LinkButton key={recentGame} to={`/game/${recentGame}`}>
                            {recentGame}
                        </LinkButton>
                    ))}
                </Container>
            )}
        </PageContainer>
    );
};

